import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import type { HowItWorksSlide } from '@swf/poker';

import type { Game, GameTypeName } from '../../../types/Game';
import { GameType } from '../../../types/Game';

import styles from './HowItWorks.scss';
import {
  TXTCLI_3_spinners_display_a_random_pr_ELL,
  TXTCLI_A_spinner_displays_a_random_pr_ELL,
  TXTCLI_Simply_select_your_buy_in_and__ELL,
  TXTCLI_Spin_X_Go_Six_is_a_fast_pacedX_ELL,
  TXTCLI_The_blinds_increase_quickly_an_ELL,
  TXTCLI_When_the_game_endsX_prizes_dra_ELL,
  TXTCLI_You_will_start_with_500_chipsX_ELL_2
} from './carouselData.messages.json';
import HighestValueGame from './components/HighestValueGame';

interface Props {
  gameType: GameTypeName;
  topPrize?: string;
  game: Game | null;
  isSharedLiquidityEnabled: boolean;
  widgetId?: string;
}

export const getCarouselData = ({
  gameType,
  topPrize,
  game,
  isSharedLiquidityEnabled,
  widgetId
}: Props): HowItWorksSlide[] => {
  if (!game) return [];
  switch (gameType) {
    case GameType.Holdem:
      return [
        {
          carouselItem: <div className={classNames(styles.container, styles.holdem1)} />,
          description: (
            <Translation
              {...TXTCLI_A_spinner_displays_a_random_pr_ELL}
              values={{ 0: topPrize?.length ? topPrize : '$1,000,000' }}
              tagName="span"
            />
          )
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.holdem2)} />,
          description: <Translation {...TXTCLI_The_blinds_increase_quickly_an_ELL} tagName="span" />
        },
        {
          carouselItem: (
            <HighestValueGame
              widgetId={widgetId}
              gameType={GameType.Holdem}
              game={game}
              isSharedLiquidityEnabled={isSharedLiquidityEnabled}
            />
          ),
          description: (
            <Translation {...TXTCLI_Simply_select_your_buy_in_and__ELL} tagName="span" />
          ),
          showLink: true
        }
      ];
    case GameType.HoldemFlash:
      return [
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemflash1)} />,
          description: (
            <Translation
              {...TXTCLI_A_spinner_displays_a_random_pr_ELL}
              values={{ 0: topPrize?.length ? topPrize : '$1,000,000' }}
              tagName="span"
            />
          )
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemflash2)} />,
          description: <Translation {...TXTCLI_The_blinds_increase_quickly_an_ELL} tagName="span" />
        },
        {
          description: (
            <Translation {...TXTCLI_Simply_select_your_buy_in_and__ELL} tagName="span" />
          ),
          carouselItem: (
            <HighestValueGame
              widgetId={widgetId}
              gameType={GameType.HoldemFlash}
              game={game}
              isSharedLiquidityEnabled={isSharedLiquidityEnabled}
            />
          ),
          showLink: true
        }
      ];
    case GameType.HoldemMax:
      return [
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemmax2)} />,
          description: (
            <Translation {...TXTCLI_You_will_start_with_500_chipsX_ELL_2} tagName="span" />
          )
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemmax1)} />,
          description: (
            <Translation
              {...TXTCLI_3_spinners_display_a_random_pr_ELL}
              values={{ 0: topPrize?.length ? topPrize : '$600,000' }}
              tagName="span"
            />
          )
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemmax5)} />,
          description: <Translation {...TXTCLI_When_the_game_endsX_prizes_dra_ELL} tagName="span" />
        },
        {
          description: (
            <Translation {...TXTCLI_Simply_select_your_buy_in_and__ELL} tagName="span" />
          ),
          carouselItem: (
            <HighestValueGame
              widgetId={widgetId}
              gameType={GameType.HoldemMax}
              game={game}
              isSharedLiquidityEnabled={isSharedLiquidityEnabled}
            />
          ),
          showLink: true
        }
      ];
    case GameType.HoldemSix:
      return [
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemsix2)} />,
          description: <Translation {...TXTCLI_Spin_X_Go_Six_is_a_fast_pacedX_ELL} tagName="span" />
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.holdemsix1)} />,
          description: (
            <Translation
              {...TXTCLI_A_spinner_displays_a_random_pr_ELL}
              values={{ 0: topPrize?.length ? topPrize : '$1,000,000' }}
              tagName="span"
            />
          )
        },
        {
          carouselItem: (
            <HighestValueGame
              widgetId={widgetId}
              gameType={GameType.HoldemSix}
              game={game}
              isSharedLiquidityEnabled={isSharedLiquidityEnabled}
            />
          ),
          description: (
            <Translation {...TXTCLI_Simply_select_your_buy_in_and__ELL} tagName="span" />
          ),
          showLink: true
        }
      ];
    case GameType.Omaha:
      return [
        {
          carouselItem: <div className={classNames(styles.container, styles.omaha1)} />,
          description: (
            <Translation
              {...TXTCLI_A_spinner_displays_a_random_pr_ELL}
              values={{ 0: topPrize?.length ? topPrize : '$1,000,000' }}
              tagName="span"
            />
          )
        },
        {
          carouselItem: <div className={classNames(styles.container, styles.omaha2)} />,
          description: <Translation {...TXTCLI_The_blinds_increase_quickly_an_ELL} tagName="span" />
        },
        {
          description: (
            <Translation {...TXTCLI_Simply_select_your_buy_in_and__ELL} tagName="span" />
          ),
          carouselItem: (
            <HighestValueGame
              widgetId={widgetId}
              gameType={GameType.Omaha}
              game={game}
              isSharedLiquidityEnabled={isSharedLiquidityEnabled}
            />
          ),
          showLink: true
        }
      ];
    default:
      return [];
  }
};
